import { useCallback } from "react";
import { LAYER_NAME } from "../../utils/constants";

/**
 * The base Layer Selector Component
 * @param {{
 *  "type": "default" | "satellite" | "hydro"
 *  "onSelect": () => void
 *  "selected": boolean | null | undefined
 * }} props
 * @returns import("react").JSX.Element
 */
export default function LayerSelector({ type, onSelect, selected }) {
  const handleSelection = useCallback(() => {
    onSelect();
  }, [onSelect]);

  return (
    <button
      style={{
        width: 32,
        height: 32,
        padding: 0,
        border: "solid 2px #00000033",
        pointerEvents: "auto",
        cursor: "pointer",
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
      }}
      onClick={handleSelection}
    >
      <img
        style={{
          width: 28,
          height: 28,
        }}
        src={`images/${type}_map_layer.png`}
        alt="layer view"
      />
      {selected ? (
        ""
      ) : (
        <p
          style={{
            color: "#000000",
            letterSpacing: 0,
            fontWight: "bold",
            marginLeft: 10,
          }}
        >
          {LAYER_NAME[type]}
        </p>
      )}
    </button>
  );
}
